(function () {
  // Moves the Wishlist Hero app's "Add to Wishlist" button to sit directly
  // under the Add to Cart button, as its own full-width bar (matching the
  // Billy J-style layout: Add to Cart, then Add to Wishlist right below it,
  // before Buy with Shop / other payment options). The button already renders
  // as a full-width bar out of the box, so this only repositions it - no
  // restyling needed.
  // The app injects its button client-side (and asynchronously on some pages),
  // so this both runs immediately and watches for it via MutationObserver.

  function relocateWishlistButton() {
    var wishlistContainer = document.querySelector(
      '.wishlisthero-product-page-button-container'
    );
    var addToCartBtn = document.querySelector('[data-add-to-cart]');

    if (!wishlistContainer || !addToCartBtn) return;
    if (wishlistContainer.dataset.relocated === 'true') return;

    wishlistContainer.dataset.relocated = 'true';
    wishlistContainer.classList.add('wishlist-bar-container');

    addToCartBtn.insertAdjacentElement('afterend', wishlistContainer);
  }

  relocateWishlistButton();

  var observer = new MutationObserver(relocateWishlistButton);
  observer.observe(document.body, { childList: true, subtree: true });

  // The wishlist app should have injected its button well within this window;
  // stop observing afterwards so we're not watching the whole DOM forever.
  setTimeout(function () {
    observer.disconnect();
  }, 15000);
})();
